// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2470":"399643ec12bce71f","2912":"7c148d9d354d585a","6714":"4331dc9d1ae376f7","7416":"f7fec09808e4a601"}[chunkId] + ".css";
};